module.exports = __webpack_public_path__ + "static/media/ccna.63f0c88f.jpg";